<template>
  <div>
    <document-placeholders
      :form="form"
      :incident="incident"
      :type="documentType?.identifier || ''"
    ></document-placeholders>

    <fieldset>
      <legend>Reasons For Hire</legend>

      <fieldset class="mt-3">
        <legend>Commuting</legend>
        <div class="col-12">
          <label class="control-label">
            TRAVELLING TO AND FROM WORK
          </label>
          <toggleswitch
            :labels="true"
            name="travelling_to_and_from_work"
            :stack="true"
            labelColumn="col-8"
            inputColumn="col-4"
            v-model="form.travelling_to_and_from_work"
            :disabled="isReadonly()"
          ></toggleswitch>

          <div class="row" v-if="form.travelling_to_and_from_work">
            <div class="col-lg-4">
              <label class="control-label">
                Distance to workplace each way
              </label>
              <input
                v-model="form.distance_to_workplace"
                name="distance_to_workplace"
                class="form-control"
                :disabled="isReadonly()"
              />
            </div>

            <div class="col-lg-4">
              <label class="control-label">
                How often is the commute to the workplace
              </label>
              <input
                v-model="form.commute_frequency"
                name="commute_frequency"
                class="form-control"
                :disabled="isReadonly()"
              />
            </div>

            <div class="col-lg-4">
              <label class="control-label">
                Shift pattern
              </label>
              <input
                v-model="form.shift_pattern"
                name="shift_pattern"
                class="form-control"
                :disabled="isReadonly()"
              />
            </div>
          </div>
        </div>
      </fieldset>
    </fieldset>

    <hr />

    <div class="col-12">
      <label class="control-label">
        Require Same Vehicle
      </label>
      <toggleswitch
        :labels="true"
        name="require_same_vehicle"
        :stack="true"
        helper="So based on this you would require the same from an accident replacement vehicle?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.require_same_vehicle"
        :disabled="isReadonly()"
      ></toggleswitch>

      <label class="control-label">
        Additional Insurance Premium Required
      </label>
      <toggleswitch
        :labels="true"
        name="additional_insurance_premium_required"
        :stack="true"
        helper="Is an additional insurance premium required for this hire?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.additional_insurance_premium_required"
        :disabled="isReadonly()"
      ></toggleswitch>

      <template v-if="form.additional_insurance_premium_required">
        <label class="control-label">
          License Less Than
        </label>

        <input
          v-model="form.license_less_than"
          name="license_less_than"
          class="form-control"
          :disabled="isReadonly()"
        />
      </template>

      <label class="control-label">
        Third Party Offered Services To Our Client?
      </label>
      <toggleswitch
        :labels="true"
        name="tp_offered_services"
        :stack="true"
        helper="Did the third party offer services to our client?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.tp_offered_services"
        :disabled="isReadonly()"
      ></toggleswitch>

      <template v-if="form.tp_offered_services">
        <label class="control-label">
          Why Didn't The Client Accept The Offer Of Services?
        </label>

        <input
          v-model="form.reasons_hire_vehicle_is_required"
          name="reasons_hire_vehicle_is_required"
          class="form-control"
          :disabled="isReadonly()"
        />
      </template>

      <label class="control-label">
        Non-Standard Driver?
      </label>
      <toggleswitch
        :labels="true"
        name="non_standard_driver"
        :stack="true"
        helper="Are any of the drivers non-standard drivers?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.non_standard_driver"
        :disabled="isReadonly()"
      ></toggleswitch>

      <template v-if="form.non_standard_driver">
        <label class="control-label">
          Under 25 or Over 70?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_age"
          :stack="true"
          helper="Are any of the riders under 25 or over 70?"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_age"
          :disabled="isReadonly()"
        ></toggleswitch>

        <label class="control-label">
          Non-Standard Occupation?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_occupation"
          :stack="true"
          helper="Are any of the riders in the following groups: Professional – Sportsmen/Women, Actors, Entertainers, Gamblers and Musicians, Publicans, Journalists?"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_occupation"
          :disabled="isReadonly()"
        ></toggleswitch>

        <label class="control-label">
          License Less Than 12 Months Old?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_license_age"
          helper="Do any of the riders have a license that is less than 12 months old?"
          :stack="true"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_license_age"
          :disabled="isReadonly()"
        ></toggleswitch>

        <label class="control-label">
          Has Convictions/Points?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_convictions"
          :stack="true"
          helper="Do any of the riders have convictions resulting in an unspent ban or 7 or more outstanding points in the last 4 years?"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_convictions"
          :disabled="isReadonly()"
        ></toggleswitch>
      </template>
    </div>
  </div>
</template>
<script>
import DocumentPlaceholders from '@/components/Modules/Shared/Children/GenerateDocument/DocumentPlaceholders';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    documentTypes: {
      type: Array,
      required: true
    }
  },

  components: {
    DocumentPlaceholders
  },

  data() {
    return {
      documentType: null
    };
  },

  methods: {},

  watch: {
    documentTypes: {
      handler(types) {
        this.documentType = types.find(
          type => type.name === 'mitigation_statement'
        );
      },
      immediate: true
    }
  }
};
</script>
